import React from 'react';
import { Grid, MenuItem } from '@material-ui/core';
import { ConfigFieldControl, ConfigTextField } from '@sierralabs/core-ui';
import { useConfigComponent } from '../../hooks/component/useConfigComponent';
import { useSubscribeComponentChanges } from '../../hooks/component/useSubscribeComponentChanges';
import { useSiteContext } from '../../SiteContext';
import { ComponentRenderer } from '../renderers';
import { SiteComponent } from '../SiteComponentPlugin';
import { SiteComponentStackConfigurator } from './SiteComponentStackPlugin';
export const SiteGrid = props => {
    var _a;
    const component = useSubscribeComponentChanges(SiteGridPlugin, props);
    const { spacing } = (component === null || component === void 0 ? void 0 : component.props) || {};
    const { isHover, hoverProps } = useSiteContext();
    const classes = ['site-grid'];
    if (isHover(component)) {
        classes.push('component-hover');
    }
    return (React.createElement(SiteComponent, Object.assign({ plugin: SiteGridPlugin }, props),
        React.createElement(Grid, Object.assign({ container: true, className: classes.join(' '), spacing: spacing || 2 }, hoverProps(component)), (_a = component.children) === null || _a === void 0 ? void 0 : _a.map(child => (React.createElement(ComponentRenderer, { key: child.id, component: child }))))));
};
export const SiteGridConfigurator = props => {
    var _a;
    const { component, update } = useConfigComponent(props.component);
    return (React.createElement(React.Fragment, null,
        React.createElement(ConfigFieldControl, null,
            React.createElement(ConfigTextField, { select: true, fullWidth: true, label: 'Spacing', value: ((_a = component.props) === null || _a === void 0 ? void 0 : _a.spacing) || 2, onChange: event => {
                    update('props.spacing', event.target.value);
                } }, [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(spacing => (React.createElement(MenuItem, { key: spacing, value: spacing }, spacing))))),
        React.createElement(SiteComponentStackConfigurator, { component: props.component })));
};
export const SiteGridPlugin = {
    name: 'Grid Container',
    type: 'grid',
    component: SiteGrid,
    configurator: SiteGridConfigurator
};
//# sourceMappingURL=SiteGridPlugin.js.map